import React, { forwardRef } from "react";
import moment from "moment";

const MFTransactionHistoryReportTable = forwardRef(
  (
    {
      tableData,
      handleTableScroll,
      hasVerticalScroll,
      scrollLoaderTable,
      loader,
      LoaderForSearch,
      clientDashboard,
    },
    ref
  ) => {
    return (
      <table className="table" style={{ width: "175%" }}>
        <thead>
          <tr>
            <th className={clientDashboard ? "text-center" : ""}>
              <span className="wrap-th">
                <span>Sr No.</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Scheme Name</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Txn Type</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Folio Number</span>
              </span>
            </th>

            <th>
              <span className="wrap-th">
                <span>Units</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>NAV</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Amount</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Stamp Duty</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>NAV Date</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Client Code</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Purchase Date</span>
              </span>
            </th>
            {hasVerticalScroll && <th className="scrollerthead"></th>}
          </tr>
        </thead>
        <tbody
          onScroll={(e) => handleTableScroll(e)}
          id="per-table-body"
          ref={ref}
        >
          {tableData?.length > 0 &&
            tableData.map((item, index) => {
              return (
                <tr key={index}>
                  <td className={clientDashboard ? "text-center" : ""}>
                    {index + 1}
                  </td>
                  <td>{item?.schemeName}</td>
                  <td>{item?.txnType || "-"}</td>
                  <td>{item?.folioNo || "-"}</td>
                  <td>{item?.units || "-"}</td>
                  <td>{item?.nav || "-"}</td>
                  <td>{item?.amount || "-"}</td>
                  <td>{item?.stampDuty || "-"}</td>
                  <td>
                    {item?.navDate
                      ? moment(item?.navDate, "DD-MMM-YYYY").format(
                          "DD-MM-YYYY"
                        )
                      : "-"}
                  </td>
                  <td>{item?.clientCode || "-"}</td>
                  <td>{item?.purchDt || "-"}</td>
                </tr>
              );
            })}
          {scrollLoaderTable && !loader && (
            <div className="loader-center">
              <LoaderForSearch />
            </div>
          )}
        </tbody>
      </table>
    );
  }
);

export default MFTransactionHistoryReportTable;
